import script from "./marketing-kyt-change-transfer-report.vue?vue&type=script&setup=true&lang=js"
export * from "./marketing-kyt-change-transfer-report.vue?vue&type=script&setup=true&lang=js"

import "./marketing-kyt-change-transfer-report.vue?vue&type=style&index=0&id=3c787c89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c787c89"]])

export default __exports__